import React from 'react';
import { CheckCircle2, XCircle, Clock } from 'lucide-react';

const Check = ({ ok, pending, label, detail, testId }) => (
  <li className="flex gap-2 text-sm" data-testid={testId}>
    {ok ? <CheckCircle2 className="w-4 h-4 text-emerald-600 mt-0.5 shrink-0" /> : pending ? <Clock className="w-4 h-4 text-amber-600 mt-0.5 shrink-0" /> : <XCircle className="w-4 h-4 text-red-600 mt-0.5 shrink-0" />}
    <div><p className="font-medium">{label}</p>{detail && <p className="text-xs text-neutral-500">{detail}</p>}</div>
  </li>
);

export const Checklist = ({ d }) => {
  const r = d.resend || {};
  const c = d.checks;
  const t = d.last_test || {};
  const dom = d.draft.sending_domain || 'Sending domain';
  return (
    <ul className="space-y-2" data-testid="email-checklist">
      <Check ok={c.connection} label="Connection Status" testId="email-check-connection"
        detail={c.connection ? (r.restricted_key ? 'Connected with a sending-only key' : 'Connected to Resend') : r.error || 'No Resend API key saved'} />
      <Check ok={c.domain_verified} pending={c.connection && !c.domain_verified} label={`Domain Verification: ${dom}`} testId="email-check-domain"
        detail={r.status ? `Resend status: ${r.status}` : r.restricted_key ? (c.domain_verified ? 'Resend accepted a test from this sender' : 'Confirmed when Resend accepts the test email') : null} />
      <Check ok={c.test_delivered} pending={t.last_event === 'sent' && !c.test_delivered} label="Test email delivered with these exact settings" testId="email-check-test"
        detail={t.at ? `${t.received_confirmed ? 'received' : t.last_event} · to ${t.to} · from ${t.sender_email}${t.error ? ` · ${t.error}` : ''}${!d.test_matches_draft ? ' · settings changed since this test, send a new one' : ''}${t.status_note && !t.received_confirmed ? ` · ${t.status_note}` : ''}` : 'No test sent yet'} />
      <Check ok={c.reply_confirmed} label="Reply reached the Reply-To inbox" testId="email-check-reply"
        detail={t.reply_confirmed && d.test_matches_draft ? `Confirmed by ${t.reply_confirmed_by}` : `Reply to the test and check ${d.draft.reply_to || 'the Reply-To inbox'}`} />
    </ul>
  );
};
